import { Component, inject } from '@angular/core';
import { ToastService } from '@/core/service/toast/toast.service';
import { ToastAction } from '@/core/models/toast.model';

@Component({
  selector: 'app-toast',
  imports: [],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css'
})
export class ToastComponent {
  toastService = inject(ToastService);

  get toasts() {
    return this.toastService.visibleToasts();
  }

  dismiss(id: string) {
    const el = document.getElementById(id);
    if (el) {
      el.classList.add('hide');
      setTimeout(() => {
        this.toastService.dismiss(id);
      }, 400);
    } else {
      this.toastService.dismiss(id);
    }
  }

  executeAction(action: ToastAction, toastId: string) {
    action.action();
    this.dismiss(toastId);
  }
}
